// extracted by mini-css-extract-plugin
export default {"version":"bt_gG"};